import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    // Redirect to index.html in public folder
    window.location.href = "/index.html";
  }, []);

  return (
    <div className="App">
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>Loading IP Filing Services...</h1>
        <p>Please wait...</p>
      </div>
    </div>
  );
}

export default App;
